export type ConversionRates = { usd: number; gbp: number; eur: number };

const perUsd = (currency: string, rates: ConversionRates): number | undefined => {
  switch (currency) {
    case "USD":
      return rates.usd;
    case "GBP":
      return rates.gbp;
    case "EUR":
      return rates.eur;
    default:
      return undefined;
  }
};

export const convertCurrency = (
  amount: number,
  from: string,
  to: string,
  rates: ConversionRates | undefined,
): number | null => {
  if (from === to) return amount;
  if (!rates) return null;
  const fromRate = perUsd(from, rates);
  const toRate = perUsd(to, rates);
  if (!fromRate || !toRate) return null;
  return (amount / fromRate) * toRate;
};
